import axios from 'axios'

export default {
    fetchJob ({ commit }, jobId) {
        return axios.get(`/api/job/${jobId}`).then((response) => {
            commit('INIT_JOB', response.data)
        })
    },

    saveDueDate ({ commit, state }, date) {
        return axios.put(`/api/job/${state.job.id}/due-date`, { required_at: date }).then((response) => {
            commit('SET_JOB', response.data)
        })
    },

    moveJob ({ commit, state }, columnId) {
        return axios.put(`/api/job/${state.job.id}/position`, { column_id: columnId })
            .then((response) => {
                commit('SET_JOB', response.data)
            })
    },

    renameJob ({ state, commit }, form) {
        return form.put(`/api/job/${state.job.id}/title`).then((response) => {
            commit('SET_JOB', response)
        })
    },

    saveDescription ({ commit, state }, form) {
        return form.put(`/api/job/${state.job.id}/description`).then((response) => {
            commit('SET_JOB', response)
        })
    },

    fetchComments ({ commit, state }) {
        return state.comments.fetch(`/api/job/${state.job.id}/comment`)
            .then((response) => {
                commit('SET_COMMENTS', response.data)
            })
    },

    fetchMembers ({ commit, state }) {
        return axios.get(`/api/job/${state.job.id}/members`).then((response) => {
            commit('SET_MEMBERS', response.data)
        })
    },

    fetchAssets ({ commit, state }) {
        return axios.get(`/api/job/${state.job.id}/asset`).then((response) => {
            commit('SET_ASSETS', response.data)
        })
    },

    addComment ({ commit, state }, form) {
        return form.post(`/api/job/${state.job.id}/comment`).then((response) => {
            response.forEach((comment) => {
                commit('ADD_COMMENT', comment)

                if (comment.attachment) {
                    commit('ADD_ASSET', comment.attachment)
                }
            })
        })
    },

    addMember ({ commit, state }, user) {
        return axios.post(`/api/job/${state.job.id}/members`, { user_id: user.id }).then((response) => {
            commit('ADD_MEMBER', response.data)
        })
    },

    removeMember ({ commit, state }, member) {
        return axios.delete(`/api/job/${state.job.id}/members/${member.id}`).then(() => {
            commit('REMOVE_MEMBER', member.id)
        })
    },

    addReaction ({ commit }, { commentId, type }) {
        return axios.post(`/api/comment/${commentId}/reaction`, { type }).then((response) => {
            commit('ADD_REACTION', response.data)
        })
    },

    removeReaction ({ commit }, reaction) {
        return axios.delete(`/api/comment/${reaction.comment_id}/reaction/${reaction.id}`).then(() => {
            commit('REMOVE_REACTION', {
                commentId: reaction.comment_id,
                reactionId: reaction.id
            })
        })
    },

    reinstateJob ({ commit }, { id, columnId }) {
        return axios.delete(`/api/job/${id}/archived`, {
            headers: { 'Content-Type': 'application/json' },
            data: { column_id: columnId }
        }).then((response) => {
            commit('SET_JOB', response.data)
        })
    }
}
